<template>	
	<div class="card checkin-info drop-down-hover mb-2">
		<div class="card-header pt-25 pb-2 d-flex bg-white text-transform-none align-items-center" :class="checkin.checkin_type.css_class_name">
			<span @click="showCheckin" data-toggle="modal" data-target="#checkinModal" class="cursor-pointer text-blue-700 font-weight-bold flex-grow-1 text-base">{{checkin.checkin_type.label}}</span>

			<div class="text-lg mr-2">
				<i
					v-if="checkin.campaign_visit"
					class="mr-1 text-gray-900 fal fa-fire-alt"
					v-tooltip.bottom="'Campaign Check-in'" />
				<i
					v-else
					class="mr-1 text-gray-400 fal fa-fire-alt"
					v-tooltip.bottom="'No Campaign'" />

				<i
					v-if="checkin.route_visit"
					class="mr-1 text-gray-900 fal fa-map-signs"
					v-tooltip.bottom="'Route Check-in'"/>
				<i
					v-else
					class="mr-1 text-gray-400 fal fa-map-signs"
					v-tooltip.bottom="'No Route'" />

				<i
					v-if="checkin.assets.length"
					class="mr-1 text-gray-900 fal fa-image"
					v-tooltip.bottom="'Assets used'" />
				<i
					v-else
					class="mr-1 text-gray-400 fal fa-image"
					v-tooltip.bottom="'No Assets'" />

				<i
					v-if="checkin.latitude"
					class="mr-1 text-gray-900 fal fa-location-circle"
					v-tooltip.bottom="'Location stored'" />
				<i
					v-else
					class="mr-1 text-gray-400 fal fa-location-circle"
					v-tooltip.bottom="'No Location'" />
			</div>

			<div class="drop-down dropleft text-base">
			  <a href="#" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-test="checkinContextMenu">
			    <i class="far fa-ellipsis-h text-xl"></i>
			  </a>
			  <div class="dropdown-menu py-0" aria-labelledby="dropdownMenuLink">
			  	<span class="dropdown-item" @click="showCheckin" data-toggle="modal" data-target="#checkinModal" data-test="viewCheckin">View Details</span>
			    <span class="dropdown-item" v-if="checkin.can.delete" @click="deleteCheckin" data-test="deleteCheckin">Delete</span>
			  </div>
			</div>
		</div>

		<div class="card-body pt-0">
			<span v-html="checkin.notes"></span>
			<div v-if="checkin.service_lines.length > 0">
				<span class="badge text-sm font-weight-normal bg-orange-200 text-orange-800 mr-1" v-for="service_line in checkin.service_lines">{{service_line.label}}</span> 
			</div>
		</div>

		<div class="card-footer py-2 text-muted d-flex align-items-center">
			<div class="rounded-circle circle-cropped avatar-xs mr-1" v-if="checkin.checkin_user"><img class="img-fluid" :src="checkin.checkin_user.photo_url"></div>
			<div class="leading-none flex-grow-1">{{ checkin.checkin_user ? checkin.checkin_user.display_name : 'unknown' }}</div>
            <div>{{ moment(checkin.created_at).format('MMM D, YYYY') }}</div>
		</div>
	</div>
</template>

<script>
	export default {
        props: {
        	checkin: Object,
        },

		data () {
			return {

			}
		},

		methods: {
			deleteCheckin() {
                this.$emit('checkin-deleted', {
                    'id': this.checkin.id,
                });
            },

            showCheckin() {
            	this.$root.$emit('checkinshow', this.checkin.id);
            },
		}
	}
</script>